import { IUserConnectionDetails } from "@Models/IUserConnectionDetails";
import React from "react";
import { Button, Card, Popconfirm } from "antd";
import Title from "antd/es/typography/Title";
import "@Styles/pages/connectionsPage.scss";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Countries } from "../../countries";
import { useHistory } from "react-router-dom";
import { QueryKeys } from "@Constants";
import { useQueryClient } from "@tanstack/react-query";
import IconButton from "@Components/shared/IconButton";

interface IConnectionItemProps extends IUserConnectionDetails {
    onAccept: (id: string) => void;
    onDecline: (id: string) => void;
    onRemove: (connectionId: string, userId: string) => void;
    onCancel: (id: string) => void;
}

const ConnectionItem: React.FC<IConnectionItemProps> = (props: IConnectionItemProps) => {
    const history = useHistory();
    const queryClient = useQueryClient();

    const redirectUserActivity = async () => {
        await queryClient.resetQueries([QueryKeys.ActivitySearchResults, props.userId]);
        history.push("/activity?user=" + props.userId);
    };

    return (
        <Card
            onClick={() => (props.status === "connected" ? redirectUserActivity() : null)}
            className={
                props.status === "connected"
                    ? "newUI-raised selectable connection-item"
                    : "newUI-subtle selectable connection-item"
            }
        >
            <div className="connection-item-top">
                <div className="connection-item-info">
                    <Title level={5}>{props.fullName}</Title>
                    <span>{Countries.get(props?.countryCode)}</span>
                    <p>{props.organisation}</p>
                </div>
            </div>

            {props.status === "received" ? (
                <div className="connection-item-actions">
                    <IconButton
                        icon={<CheckOutlined />}
                        className="secondary"
                        size="middle"
                        onClick={() => props.onAccept(props.connectionId)}
                    >
                        Accept
                    </IconButton>
                    <IconButton
                        icon={<CloseOutlined />}
                        className="secondary danger"
                        size="middle"
                        onClick={() => props.onDecline(props.connectionId)}
                    >
                        Decline
                    </IconButton>
                </div>
            ) : (
                <div className="connection-item-actions-single danger" onClick={(e) => e.stopPropagation()}>
                    {props.status === "connected" && (
                        <Popconfirm
                            title="Are you sure you want to remove this connection?"
                            onConfirm={() => props.onRemove(props.connectionId, props.userId)}
                            okText="Remove"
                            cancelText="Cancel"
                            cancelButtonProps={{ className: "secondary" }}
                        >
                            <Button className="secondary">Remove</Button>
                        </Popconfirm>
                    )}
                    {props.status === "sent" && (
                        <Popconfirm
                            title="Are you sure you want to withdraw this request?"
                            onConfirm={() => props.onCancel(props.connectionId)}
                            okText="Withdraw"
                            cancelText="Cancel"
                            cancelButtonProps={{ className: "secondary" }}
                        >
                            <Button className="secondary danger">Withdraw request</Button>
                        </Popconfirm>
                    )}
                </div>
            )}
        </Card>
    );
};
export default ConnectionItem;
